
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[pageLocale]/companies/[companySlug]/teams",
      function () {
        return require("private-next-pages/[pageLocale]/companies/[companySlug]/teams.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[pageLocale]/companies/[companySlug]/teams"])
      });
    }
  